export default __webpack_public_path__ + "static/media/mobile_shop_v3.71102292.png";